module.exports = __webpack_public_path__ + "static/media/8_fripulia2_62.19_3.24.06b0b667.png";